<div class="flex flex-col h-full">
    <div class="flex-1 overflow-auto mb-2">
        <div class="min-w-max">
            <ng-content select="app-table-head"></ng-content>
            @if (loading()) {
                <div class="bg-shui-base-2 my-2 py-3 pr-4 pl-8 rounded-md h-11 animate-pulse"></div>
                <div class="bg-shui-base-2 my-2 py-3 pr-4 pl-8 rounded-md h-11 animate-pulse opacity-90"></div>
                <div class="bg-shui-base-2 my-2 py-3 pr-4 pl-8 rounded-md h-11 animate-pulse opacity-80"></div>
                <div class="bg-shui-base-2 my-2 py-3 pr-4 pl-8 rounded-md h-11 animate-pulse opacity-70"></div>
                <div class="bg-shui-base-2 my-2 py-3 pr-4 pl-8 rounded-md h-11 animate-pulse opacity-60"></div>
            } @else {
                <ng-content select="app-table-row"></ng-content>
            }
        </div>
        @if (!loading() && totalItems() === 0) {
            <div class="w-full py-8 flex items-center justify-center">
                <span class="text-shui-ui-6">No items to display.</span>
            </div>
        }
    </div>
    <app-paginator
        [pageSize]="pageSize()"
        [currentPage]="currentPage()"
        [totalItems]="totalItems()"
        (pageChange)="pageChange.emit($event)"
        (pageSizeChange)="pageSizeChange.emit($event)"
    ></app-paginator>
</div>
